import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { ScrollList } from '../shared/ScrollList';
import { Button } from '../shared/Button';
import { CmsConstants } from '../../Business/cms/CmsConstants';

export class CmsTabbedRibbon extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: Theme.Fonts.Ribbon.Title.lineHeight,
      color: Theme.Colors.Transparent,
      rect: true,
      Title: {
        y: 0,
        h: Theme.Fonts.Ribbon.lineHeight,
        text: {
          ...Theme.Fonts.Ribbon.Title,
        },
        color: Theme.Colors.Ribbon.Title,
      },
      Tabs: {
        y: 0,
        w: w => w,
        type: ScrollList,
        direction: 'row',
        peekNext: true,
        signals: {
          onActivate: '_onTabSelect',
        },
      },
      Ribbon: {
        w: w => w,
      },
    };
  }

  _init() {
    this.focusIndex = 0;
    if (!this.contentOffset) this.contentOffset = 0;
    this.selectedTab = this.defaultTab ? this.defaultTab : 0;
    this.focusList = [this.tag('Tabs'), this.tag('Ribbon')];
    this.updateTitle();
    this.updateTabs();
    this.updateItems();
  }

  updateTitle() {
    const title = this.tag('Title');
    const tabs = this.tag('Tabs');
    title.x = CmsConstants.Ribbon.titleOffset + this.contentOffset;
    tabs.x = this.contentOffset;
    if (this.data.title) {
      title.text.text = this.data.title;
      title.visible = true;
      tabs.y = Theme.Fonts.Ribbon.Title.lineHeight;
    } else {
      title.visible = false;
      tabs.y = 0;
    }
  }

  set selectedTab(val) {
    this._selectedTab = val;
    this.tag('Tabs').items.childList.forEach(tab => {
      tab.buttonActive = false;
    });
    if (this.tag('Tabs').items.children.length > val) {
      this.tag('Tabs').items.children[val].buttonActive = true;
      this.tag('Tabs').focusTo(val);
    }
  }

  get selectedTab() {
    return this._selectedTab;
  }

  updateTabs() {
    const title = this.tag('Title');
    const tabs = this.tag('Tabs');
    const items = this.tag('Ribbon');

    const tabHeight = this.data.buttonHeight;

    let content = this.data.seasonRibbons;

    content.forEach((season, idx) => {
      tabs.items.childList.a({
        type: Button,
        buttonMode: 'textButton',
        h: tabHeight,
        label: season.title,
        buttonIndex: idx,
        passSignals: {
          onActivate: true,
        },
      });
    });
    this.selectedTab = this.defaultTab ? this.defaultTab : 0;
    items.y = title.visible * Theme.Fonts.Ribbon.Title.lineHeight + tabHeight;
  }

  updateItems() {
    const title = this.tag('Title');
    const ribbon = this.tag('Ribbon');
    ribbon.childList.clear();

    let ribbonDef = this.data.seasonRibbons[this.selectedTab];
    const dataSource = ribbonDef.dataSource;
    // reset loaded point, datasource should handle returning cached items instead of next page
    dataSource.loadedIdx = 0;
    // load datasource so that cardsize is known
    dataSource._fetchPage(0).then(() => {
      let height = dataSource.sizeInfo.height;
      ribbon.h = height;
      if (title.visible) {
        this.h = height + Theme.Fonts.Ribbon.Title.lineHeight + this.data.buttonHeight;
      } else {
        this.h = height + this.data.buttonHeight;
      }

      ribbon.childList.a({
        passSignals: { centerVertical: true },
        signals: { centerVertical: '_handleCardCentralVertical' },
        contentOffset: this.contentOffset,
        ...dataSource.componentDescription(),
      });
    });
  }

  _onTabSelect(button) {
    this.selectedTab = button.buttonIndex;
    this.updateItems();
  }

  _getFocused() {
    return this._getFocusable()[this.focusIndex];
  }

  _focus() {
    let focused = this._getFocusable()[this.focusIndex];
    if (focused === this.tag('Tabs')) {
      let activeRibbon = this.tag('Ribbon').children[0];
      if (activeRibbon && activeRibbon.centerCard) activeRibbon.centerCard();
      else this.signal('centerVertical', this.finalY + this.finalH * 0.5);
    }
  }

  _handleCardCentralVertical(val) {
    this.signal('centerVertical', this.finalY + val);
  }

  _handleDown() {
    let prevValue = this.focusIndex;
    this.focusIndex = Math.min(this.focusIndex + 1, this._getFocusable().length - 1);
    return prevValue !== this.focusIndex;
  }

  _handleUp() {
    let prevValue = this.focusIndex;
    this.focusIndex = Math.max(this.focusIndex - 1, 0);
    return prevValue !== this.focusIndex;
  }

  _getFocusable() {
    let result = [];
    if (this.tag('Tabs').items.children.length > 1) {
      result.push(this.tag('Tabs'));
    }
    if (this.tag('Ribbon').children.length > 0) {
      result.push(this.tag('Ribbon').children[0]);
    }
    return result;
  }
}
